import { Link } from "react-router";
import PropTypes from "prop-types";

/**
 * Footer component with navigation links.
 * @param {Object} props Component props
 */
export function Footer(props) {
  return (
    <footer title="Color Steps" className="footer">
      <nav className="footer-nav container">
        <span className="footer-nav--name">Color Palette Tool</span>
        <ul className="footer-nav--links">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/about/">About</Link>
          </li>
        </ul>
      </nav>
    </footer>
  );
}

Footer.propTypes = {
  profile: PropTypes.shape({
    facebook: PropTypes.object,
    google: PropTypes.object,
  }),
  onSettingsClick: PropTypes.func,
  onProfileClick: PropTypes.func,
};
Footer.defaultProps = {
  profile: undefined,
  onSettingsClick: () => {},
  onProfileClick: () => {},
};
